__turbopack_context__.v({
  "buttons": "ITNCoverage-module-scss-module__pR-TKG__buttons",
  "content": "ITNCoverage-module-scss-module__pR-TKG__content",
  "explenation": "ITNCoverage-module-scss-module__pR-TKG__explenation",
  "graphWrapper": "ITNCoverage-module-scss-module__pR-TKG__graphWrapper",
  "image": "ITNCoverage-module-scss-module__pR-TKG__image",
  "imageWrapper": "ITNCoverage-module-scss-module__pR-TKG__imageWrapper",
  "subtitle": "ITNCoverage-module-scss-module__pR-TKG__subtitle",
  "wrapper": "ITNCoverage-module-scss-module__pR-TKG__wrapper",
});
